import { Sparkles, Reply } from "lucide-react";
import { Glass } from "./Glass";

export const FloatingGlassPanel = ({ chip }) => {
  if (chip.kind === "ai") {
    return (
      <Glass variant="light" className="flex items-center gap-3 rounded-2xl px-4 py-3" data-testid={`hero-chip-${chip.id}`}>
        <span className="grid h-9 w-9 place-items-center rounded-full bg-gradient-to-br from-[#7866E8] to-[#80D9EB] text-white">
          <Sparkles size={16} aria-hidden />
        </span>
        <span className="leading-tight">
          <span className="block text-[14px] font-semibold text-[#08090D]">{chip.text}</span>
          <span className="block text-[12px] text-[#4b4f63]">{chip.sub}</span>
        </span>
      </Glass>
    );
  }
  return (
    <Glass variant="light" className="flex items-center gap-2.5 rounded-full py-2 pl-2 pr-4" data-testid={`hero-chip-${chip.id}`}>
      <img src={chip.avatar} alt="" className="h-8 w-8 rounded-full object-cover" />
      {chip.kind === "reply" && <Reply size={14} className="text-[#7866E8]" aria-hidden />}
      <span className="text-[14px] font-medium text-[#08090D]">
        {chip.name && <span className="font-semibold">{chip.name}: </span>}
        {chip.text}
      </span>
    </Glass>
  );
};
